import {
  useStyle 
} from "@/classify"
import {
  deriveOptionCodesFromProduct,
  getCustomAttributes
} from "@/util/productFullDetailUtil"
import {
  useMemo, useState 
} from "react"
import {
  ProductRoot 
} from "../../types/product"
import CustomAttributes from "../../CustomAttributes"
import defaultClasses from "./pageBuilderAttributes.module.css"


export const PageBuilderAttributes = ({
  product,
  optionSelections
}: {
    product: ProductRoot
    optionSelections: any
}) => {
    
  const classes = useStyle(defaultClasses)

  const derivedOptionCodes = useMemo(
    () => deriveOptionCodesFromProduct(product),
    [product]
  )
  const [optionCodes] = useState(derivedOptionCodes)

  const customAttributes = useMemo(
    () => getCustomAttributes(product, optionCodes, optionSelections),
    [product, optionCodes, optionSelections]
  )

  const customAttributesDetails = useMemo(() => {
    const list = []
    const pagebuilder: any = []
    const skuAttribute = {
      attribute_metadata: {
        uid: "attribute_sku",
        used_in_components: ["PRODUCT_DETAILS_PAGE"],
        ui_input: {
          ui_input_type: "TEXT",
        },
        label: "SKU",
      },
      entered_attribute_value: {
        value: product.sku,
      },
    }

    if (Array.isArray(customAttributes)) {
      customAttributes.forEach((customAttribute) => {
        if (
          customAttribute.attribute_metadata.ui_input
            .ui_input_type === "PAGEBUILDER"
        ) {
          pagebuilder.push(customAttribute)
        } else {
          list.push(customAttribute)
        }
      })
    }

    list.unshift(skuAttribute)

    return {
      list: list,
      pagebuilder: pagebuilder,
    }
  }, [customAttributes, product.sku])

  if (customAttributesDetails?.pagebuilder?.length === 0) {
    return null
  }

  return (
    <section className={classes.detailsPageBuilder}>
      <CustomAttributes
        classes={{
          list: classes.detailsPageBuilderList 
        }}
        customAttributes={customAttributesDetails.pagebuilder}
        showLabels={false}
      />
    </section>
  )
}
